<template>

    <div class="builder-modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-body">
                    <span v-if="title" class="title">{{ title }}</span>
                    <slot name="body"></slot>
                </div>
                <div class="modal-footer">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .builder-modal {
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
        z-index: 1001;
        .modal-dialog {
            @include shad(2);
            background: #fff;
            border-radius: 5px;
            left: 50%;
            margin-left: -(400px / 2);
            margin-top: 30px;
            max-width: 100%;
            overflow: hidden;
            position: absolute;
            top: 0;
            width: 400px;
        }
        .modal-body {
            @include font-medium(13px);
            line-height: 1.6em;
            padding: 20px;
            position: relative;
            *:last-child {
                margin-bottom: 0;
            }
            p {
                margin: 0 0 20px 0;
            }
            .title {
                @include font-medium(14px);
                display: block;
                margin-bottom: 15px;
            }
        }
        .modal-footer {
            border-top: 1px solid $color-rule;
            display: flex;
            justify-content: space-between;
            padding: 15px;
        }
    }

</style>

<script>

export default {

    props: {
        title: {
            type: String,
        },
    },

}

</script>